import { z } from 'zod'
import { isValidPhoneNumber } from 'libphonenumber-js/max'

export const phoneNumberSchema = z.string()
  .transform((p) => {
    const noSpaces = p.replace(/\s+/g, '')
    
    if (!noSpaces) {
      return noSpaces
    }

    // Normalize: ensure it starts with +
    let normalized = noSpaces
    if (!normalized.startsWith('+')) {
      normalized = normalized.length === 10 ? `+1${normalized}` : `+${normalized}`
    }
    
    return normalized
  })
  .superRefine((val, ctx) => {
    if (!val) return // empty is allowed here, caught by required rule if needed

    if (!/^\+?[0-9]+$/.test(val)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Only numbers and an optional leading + are allowed',
      })
      return
    }

    // Validate using libphonenumber-js (country-aware validation)
    if (!isValidPhoneNumber(val)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
      message: 'Invalid phone number',
      })
    }
  })
